import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import 'rxjs/add/operator/switchMap';

import { ReleaseBundleService, ReleaseBundle } from '../release-bundle/release-bundle.service';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { environment } from '../../environments/environment';
import { Message, MenuItem } from 'primeng/primeng';

import { HomeService } from '../home/home.service';
import { MainService } from '../main.service';
import { NewReleaseService } from '../new-release/new-release.service';
import { FileUploader } from 'ng2-file-upload';
import { MatDialog } from '@angular/material';
import { ReleaseEditModelComponent } from '../shared/release-edit-model/release-edit-model.component';
import { AddComponentsToBundleComponent } from '../shared/add-components-to-bundle/add-components-to-bundle.component';

// import { ConfirmationService } from 'primeng/primeng';

const DownloadURL = environment.downloadURL;
const ZipDownloadURL = environment.zipDownloadURL;
// const URL = environment.uploadURL;
const URL = "/upload"

@Component({
  selector: 'app-release-bundle-details',
  templateUrl: './release-bundle-details.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  styleUrls: ['../../style.scss',
    './release-bundle-details.component.css']
})
export class ReleaseBundleDetailsComponent implements OnInit {

  fromDate: Date = new Date(new Date().getTime() - (30 * 24 * 60 * 60 * 1000));
  toDate: Date = new Date();
  formatFromDate: string;
  formatToDate: string;
  fdMonth: string | number;
  toMonth: string | number;

  msgs: any[];
  items: MenuItem[];
  dropdownItems: MenuItem[];
  bundleName: any;
  bundleDesc: any;
  bundleFlow: number;
  bundleUatDate: any;
  bundleProject: String;
  bundleProjectID: number;
  bundleProjectName: String;
  bundleData: any[];
  bundleMeatadata: any[];
  bundleDownloadData: any[];
  releaseBundleID: any;
  dataOptions: {};
  removeOptions: {};
  dataDownloadOptions: {};
  downloadOptions: {};
  options: {};
  bundleOptions: {};
  changeWorkFlowOptions: {};
  uploadNoteOptions: {};
  projectOptions: {};
  activityResponce: any;
  responce: any;
  isClient: boolean;
  display: boolean = false;
  removeRelease: any;
  isEdit: boolean = false;
  isEditDesc: boolean = false;
  workFlowList: any;
  _rid: any;
  _workflow: any;
  workflow_id :any;
  projectList: any;
  showDetails: boolean = false;
  isDisplay: String;
  hasEditAccess: boolean = false;

  releaseBundle: any;
  releaseBundleProject: any;
  releaseBundleProjectID: any;

  userEmail = localStorage.getItem('userEmail');
  userName = localStorage.getItem('userName');
  isTour = localStorage.getItem('isTour');
  is_Admin = localStorage.getItem('is_Admin');

  // workflows to display in 'change state' button
  workflows = ['Dev', 'QA', 'UAT', 'Prod'];
  bundleNoteDataOptions: {};
  projectName: any;
  componentName: any;
  isFileSelected: boolean;
  originalFileName_BundleNote: any;
  fileName_BundleNote: any;
  enableReleaseUpload: boolean;
  isUploaded: boolean;
  bundleNote: any;
  bundleNoteLoc: any;
  isBundle: boolean = false;
  passedBundle: any;
  bundleNoteDIR: String;
  fileStatus: String;
  pagebundleid: any;

  constructor(
    private bundleService: ReleaseBundleService,
    private homeService: HomeService,
    private route: ActivatedRoute,
    private router: Router,
    private mainService: MainService,
    private newReleaseService: NewReleaseService,
    public dialog: MatDialog,
    public dialogComp: MatDialog,
  ) {
    const id: string = route.snapshot.params.id;
    this.releaseBundleID = id;

  }


  goToBundles() {
    this.router.navigate(['/bundles']);
  }

  checkClient() {
    this.isClient = this.userEmail.includes("@");
  }

  showConfirmation(release: { createdBy: string; qa: string; }) {
    if (release.createdBy == this.userName || release.qa == this.userName || this.is_Admin == '1') {
      this.display = true;
      this.removeRelease = release;
    } else {
      this.msgs = [];
      this.msgs.push({ severity: 'warn', summary: 'Remove release from bundle', detail: 'No Permission' });
    }

  }

  confirmRemove() {
    this.removeFromBundle(this.removeRelease);
  }

  removeFromBundle(rb: { releaseId: null; rbd_id: null; bundleId: any; cid: any; }) {


    if (rb.releaseId != null) {
      rb.rbd_id = null;
    }

    // if (rb.r_id != null) {
    //   rb.rbd_id = null;
    // }

    this.removeOptions = {
      bundle_id: rb.bundleId,
      release_id: rb.releaseId,
      rbd_id:  rb.releaseId,
      component:  rb.cid
    };

    // this.removeOptions = {
    //   bundle_id: rb.b_id,
    //   release_id: rb.r_id,
    //   rbd_id: rb.rbd_id,
    //   component: rb.cid
    // };


    this.bundleService.removeFromBundle(this.removeOptions).then(remove => {

      if (remove.res != undefined) {
        this.msgs = [];
        this.msgs.push({ severity: 'success', summary: 'Removed from bundle' });

        this.getBundleData();

        this.getBundleMetadData();

      } else {
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'Error occurred while removing release from bundle ! ' });
      }
    });
  }


  edit() {
    this.isEdit = true;
  }

  editDesc() {
    this.isEditDesc = true;
  }

  editName() {
    this.isEdit = false;

    this.bundleOptions = {
      bundle_id: this.releaseBundleID,
      name: this.bundleName,
      desc: this.bundleDesc
    };

    this.bundleService.editReleaseBundle(this.bundleOptions).then(res => {
      this.responce = res;

      if (this.responce.status == 'edited') {
        this.msgs = [];
        this.msgs.push({ severity: 'success', summary: 'Bundle Name Edited' });

        setTimeout(() => {
          this.getBundleData();
        },
          100);

      } else {
        alert(this.responce);
      }

    });
  }


  editDescript() {
    this.isEditDesc = false;

    this.bundleOptions = {
      bundle_id: this.releaseBundleID,
      name: this.bundleName,
      desc: this.bundleDesc
    };

    this.bundleService.editReleaseBundle(this.bundleOptions).then(res => {
      this.responce = res;

      if (this.responce.status == 'edited') {
        this.msgs = [];
        this.msgs.push({ severity: 'success', summary: 'Bundle Description Edited' });

        setTimeout(() => {
          this.getBundleData();
        },
          100);

      } else {
        alert(this.responce);
      }

    });
  }

  // view release
  onRowSelect(s: { releaseId: string; }) {

    localStorage.setItem('previousURL', '/Release-Bundles/' + this.route.snapshot.params.id);

    setTimeout(() => {
      this.router.navigate(['/release/' + s.releaseId]);
    },
      500);

  }

  // download release 
  sendLocation(s: { download_link: any; file_name: any; }) {

    this.downloadOptions = {
      locaction: s.download_link
    };

    this.options = {
      user: this.userEmail,
      action: "Download Release",
      file: s.file_name
    };

    this.homeService.sendActivity(this.options).then(res => {
      this.activityResponce = res;
    });

    this.homeService.downloadFile(this.downloadOptions).then(downloaded => {
      this.responce = downloaded;
    });

  }

  // download release 
  sendNoteLocation(note: any) {

    this.downloadOptions = {
      locaction: note
    };

    this.options = {
      user: this.userEmail,
      action: "Download Bundle Note",
      file: this.bundleNote
    };

    this.homeService.sendActivity(this.options).then(res => {
      this.activityResponce = res;
    });

    this.homeService.downloadFile(this.downloadOptions).then(downloaded => {
      this.responce = downloaded;
    });

  }

  getWorkflow() {
    this.mainService.getWorkflow(this.options).then(workflow => {
      this.workFlowList = workflow;

      this.items = [];
      for (var i = 0; i < this.workFlowList.length; i++) {

        if (i != 0) {
          var obj = { label: this.workFlowList[i].workflow };
          this.items.push(obj);

        }
      }
    });
  }


  getDownload() {

    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: 'Downloading.....' });
    setTimeout(() => {
      window.location.href = DownloadURL;
    },
      1000);

  }

  getBundleDownloadData(bundleData: any) {
    this.dataDownloadOptions = {
      bundle_id: this.releaseBundleID
    };

    this.bundleDownloadData = [];
    this.homeService.getBundleDownloadData(this.dataDownloadOptions).then(bundle => {
      if (bundle.length != undefined) {
        this.bundleDownloadData = bundle;
        this.getArchiveURL(this.bundleDownloadData);
      } else {
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'No Data' });
      }
    });
  }

  getArchiveURL(archiveData: string | any[]) {
    var locations: string;
    var file: string;

    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: 'Zipping the bundle', detail: " This may take around 1 min ;)", life: 60000 });

    for (var i = 0; i < archiveData.length; i++) {
      if (locations != undefined && file != undefined) {
        locations = locations + ',' + archiveData[i].location;
        file = file + ',' + archiveData[i].file;
      } else {
        locations = archiveData[0].location;
        file = archiveData[0].file;
      }

    }

    for (var i = 0; i < archiveData.length; i++) {
      if (locations != undefined && file != undefined) {
        if (archiveData[i].note_location) {
          locations = locations + ',' + archiveData[i].note_location;
        }
      } else {
        locations = archiveData[0].note_location;
      }
    }


    this.dataOptions = {
      locationList: locations,
      fileList: file,
      bundle_name: archiveData[0].bundleName
    };

    this.homeService.getArchiveDownloadURL(this.dataOptions).then(res => {
      if (res.zip != undefined) {
        const downloadArchive = {
          "download_link": res.zip
        }

        
        this.getArchive(res.zip);
        this.getDownload()
        // this.sendLocation(downloadArchive);
        // this.sendLocation(res.zip);
        // this.getArchive(res.zip);
      } else {
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'No Data' });
      }
    });
  }

  getArchive(URL: any) {
    this.downloadOptions = {
      locaction: URL
    };

    this.homeService.downloadFile(this.downloadOptions).then(downloaded => {
      this.responce = downloaded;

      // this.getZipDownload();
    });
  }

  // sendLocation(s: Release) {
  //   console.log("storage location", s.storage_location);
  //   this.downloadOptions = {
  //     locaction: s.storage_location
  //   };

  //   this.options = {
  //     user: this.userEmail,
  //     action: "Download Release",
  //     file: s.file_name
  //   };

  //   this.homeService.sendActivity(this.options).then(res => {
  //     this.activityResponce = res;
  //   });

  //   this.homeService.downloadFile(this.downloadOptions).then(downloaded => {
  //     this.responce = downloaded;
  //   });

  // }

  getZipDownload() {

    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: 'Downloading.....' });
    setTimeout(() => {
      window.location.href = ZipDownloadURL;
    },
      1000);

  }


  getBundleData() {
 
    this.dataOptions = {
      bundle_id: this.pagebundleid
    };

    this.bundleData;
    this.bundleService.getReleaseBundleData(this.dataOptions).subscribe(bundle => {

      if (bundle.length != undefined) {
        for (var i = 0; i < bundle.length; i++) {
          this.bundleData = bundle;
          
       /*   this.bundleName = this.bundleData[i].bundleName;
          this.bundleDesc = this.bundleData[i].description;          ;
          this.bundleFlow = this.bundleData[i];

          this.bundleProject = this.bundleMeatadata[0].pkey;
          this.bundleProjectName = this.bundleMeatadata[0].project;
          this.bundleProjectID = this.bundleMeatadata[0].project_id;
          //this.bundleNote = this.bundleData[i].bundle_note;
          //this.bundleNoteLoc = this.bundleData[i].note_location;
          if (this.bundleData[i].uat_date != null) {
            this.bundleUatDate = this.bundleData[i].uat_date;
          } else {
            this.bundleUatDate = "- -";
          }*/

        }


        if (this.projectList == undefined) {
          this.getProjects();
        }

        setTimeout(() => {
          for (var i = 0; i < this.projectList.length; i++) {
            if (this.projectList[i].key === this.bundleProject) {
              this.showDetails = true;
            } else if (this.is_Admin == '1') {
              this.showDetails = true;
            }
          }
          
          if (this.showDetails === false) {
            this.isDisplay = "You Don't Have Permission to view this Bundle...";
          }
        },
          500);

      } else {
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'No Data' });
      }
    });

    
  }

  getBundleMetadData() {

    this.dataOptions = {
      bundle_id: this.releaseBundleID
    };

    this.bundleData = [];
    this.bundleService.GetBundleMetadata(this.dataOptions).then(bundle => {

      if (bundle.length != undefined) {
        this.bundleMeatadata = bundle;
        this.bundleName = this.bundleMeatadata[0].bundleName;
        this.bundleDesc = this.bundleMeatadata[0].desc;
        this.bundleFlow = this.bundleMeatadata[0];
        this.bundleProject = this.bundleMeatadata[0].pkey;
        this.bundleProjectName = this.bundleMeatadata[0].project;
        this.bundleProjectID = this.bundleMeatadata[0].project_id;
        this.bundleNote = this.bundleMeatadata[0].bundle_note;
        this.bundleNoteLoc = this.bundleMeatadata[0].note_location;
        if (this.bundleMeatadata[0].uat_date != null) {
          this.bundleUatDate = this.bundleMeatadata[0].uat_date;
        } else {
          this.bundleUatDate = "- -";
        }

        // check edit access
        if (this.bundleMeatadata[0].created_by == this.userName || this.is_Admin == '1') {
          this.hasEditAccess = true;
        }

        if (this.projectList == undefined) {
          this.getProjects();
        }

        setTimeout(() => {

          for (var i = 0; i < this.projectList.length; i++) {
            if (this.projectList[i].key === this.bundleProject) {
              this.showDetails = true;
            }
            else if (this.is_Admin == '1') {
              this.showDetails = true;
            }
          }

          if (this.showDetails === false) {
            this.isDisplay = "You Don't Have Permission to view this Bundle...";
          }
        },
          500);

      } else {
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'No Data' });
      }
    });
  }

  


  changeWorkFlow(bd: { b_id: any; workflow_id: any; }) {
    this._rid = bd.b_id;
    this._workflow = bd.workflow_id;

    //var editStage: any[] = this.bundleData.filter(temp =>     temp.workflow_id == bd.workflow_id);
    var editStage = [] ; 
    editStage.push(bd);

    if (this._workflow < 4) {
      editStage[0].workflow_id += 1;
      this._workflow = editStage[0].workflow_id;

      this.changeWorkFlowOptions = {
        bundle_id: this._rid,
        workflow: this._workflow
      }

      this.bundleService.editReleaseBundleWorkflow(this.changeWorkFlowOptions).then(workflow => {
        this.msgs = [];
        this.msgs.push({ severity: 'success', summary: 'Stage Updated' });

        setTimeout(() => {
          this.getBundleData();
        },
          0.5);

      });

    }

  }

  fileEventBundleNote(e: any) {

    this.isFileSelected = true;
    this.fileStatus = 'Bundle_Notes';

    let file = e.target.files[0];

    this.originalFileName_BundleNote = file.name;
    // Used substring to get only the file name
    this.fileName_BundleNote = file.name.substring(0, file.name.lastIndexOf('.'));

  }

  public uploader: FileUploader = new FileUploader({ url: URL });
  public hasBaseDropZoneOver = false;
  public hasAnotherDropZoneOver = false;

  public uploadData() {

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Uploaded', detail: item.file.name });
      if (response) {
        if (response.includes("Bundle_Notes")) {
          this.bundleNoteDIR = response;
        } else {
          console.log("DIR Err");
        }
      } else {
        this.msgs.push({ severity: 'Error', summary: 'Upload Error' });
      }

      this.isUploaded = true;
      this.uploader.queue = [];
      this.uploadReleaseBundleNote();
    };


    this.uploader.onCompleteAll = () => {

      this.isUploaded = true;

    };

    this.uploader.onErrorItem = (item: any, response: any, status: any, headers: any) => {
      this.msgs = [];
      this.msgs.push({ severity: 'Error', summary: 'Upload Failed' });
    };
  }

  public removeFile() {
    this.enableReleaseUpload = true;
  }

  public removeFiles() {
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  uploadReleaseBundleNote() {
    this.uploadNoteOptions = {
      bundle_id: this.releaseBundleID,
      note: this.bundleNoteDIR ? this.fileName_BundleNote : '',
      // note_location: this.originalFileName_BundleNote ? '../Uploads/Bundle_Notes/' + this.bundleProject + '/' + this.bundleName + '/' + this.fileName_BundleNote + '/' + this.originalFileName_BundleNote : '',
      note_location: this.originalFileName_BundleNote ? this.bundleNoteDIR : '',
    }

    this.bundleService.uploadReleaseBundleNote(this.uploadNoteOptions).then(workflow => {
      this.msgs = [];
      this.msgs.push({ severity: 'success', summary: 'Bundle Note Uploaded' });

      setTimeout(() => {
        this.getBundleData();
      },
        0.5);

    });
  }



  showUpload(data: { component: any; cid: any; qa: any; created_by: any; rbd_id: any; }) {

    var uploadData = {
      project: this.bundleMeatadata[0].project,
      project_id: this.bundleMeatadata[0].project_id,
      pkey: this.bundleMeatadata[0].pkey,
      component: data.component,
      cid: data.cid,
      workflow: 'Dev',
      qa: data.qa,
      owner: data.created_by,
      rbd_id: data.rbd_id,
      is_Upload: true
    }

    const dialogRef = this.dialog.open(ReleaseEditModelComponent, {
      width: '900px',
      data: uploadData
    });

    dialogRef.afterClosed().subscribe(result => {
      setTimeout(() => {
        this.getBundleData();
      },
        500);
    });
  }

  getProjects() {
    var that = this;
    this.projectOptions = {
      user: this.userEmail
    };
    this.mainService.getProjectList(this.projectOptions).then(projects => {
      that.projectList = projects;

    });
  }

  getVersionForBundle(bundle: { bundleName: any; project: any; project_id: any; b_id: any; }) {

    this.passedBundle = bundle;
    this.releaseBundle = bundle.bundleName;
    this.releaseBundleProject = bundle.project;
    this.releaseBundleProjectID = bundle.project_id ? bundle.project_id : this.bundleMeatadata[0].project_id;
    this.releaseBundleID = bundle.b_id;
    this.isBundle = true;

    this.fdMonth = (this.fromDate.getMonth() + 1);
    this.formatFromDate = this.fromDate.getDate() + '/' + this.fdMonth + '/' + this.fromDate.getFullYear();

    this.toMonth = (this.toDate.getMonth() + 1);
    this.formatToDate = this.toDate.getDate() + '/' + this.toMonth + '/' + this.toDate.getFullYear();

    localStorage.setItem("rbFromDate", JSON.stringify(this.fromDate));
    localStorage.setItem("rbToDate", JSON.stringify(this.toDate));

    this.options = {
      fd: this.formatFromDate,
      td: this.formatToDate,
      p: this.releaseBundleProject,
      c: '',
      pList: '',
      cList: '',
      workflow: ''
    };

  }


  onNeedReload(message: boolean): void {
    if (message) {
      this.getBundleData();
    }
  }

  ondialogClosed(message: boolean): void {
    setTimeout(() => {
      this.isBundle = message;
    },
      1000);

  }

  addComponents(passedBundle: any) {
    const dialogRefComp = this.dialogComp.open(AddComponentsToBundleComponent, {
      width: '900px',
      data: passedBundle
    });

    dialogRefComp.afterClosed().subscribe(result => {
      setTimeout(() => {
        this.getBundleData();
      },
        200);
    });

  }

  getBundleMainData(data: any) {
    this.passedBundle = data;
    this.passedBundle.project_id = this.bundleMeatadata[0].project_id;
    this.passedBundle.pkey = this.bundleMeatadata[0].pkey;
  }

  getPageBundleId() {
    const url = window.location.href; // Get the current URL
    const parts = url.split('/'); // Split the URL by '/'
    // Get the last part of the URL which should be the desired value
    this.pagebundleid = parseInt(parts[parts.length - 1]);
  }

  ngOnInit() {

    this.getPageBundleId();

    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      form.append('project', this.bundleProject);
      form.append('bundle', this.bundleName);
      form.append('type', this.fileStatus);
    };


    this.dropdownItems = [
      {
        label: ' Components', icon: 'fa-plus-square', command: () => {
          this.addComponents(this.passedBundle);
        }
      }
    ];


    this.checkClient();

    this.getWorkflow();

    this.getProjects();

    setTimeout(() => {

      // load bundle metadata
      this.getBundleMetadData();

      this.getBundleData();
    },
      1000);

  }
}
